module.exports = __webpack_public_path__ + "static/media/LowWaterDemand.693fe325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/LowWaterDemand.png
// module id = 645
// module chunks = 0